import { render } from "./NcrmPersonDetails.vue?vue&type=template&id=5ff73fa1&scoped=true"
import script from "./NcrmPersonDetails.vue?vue&type=script&lang=js"
export * from "./NcrmPersonDetails.vue?vue&type=script&lang=js"

import "./NcrmPersonDetails.vue?vue&type=style&index=0&id=5ff73fa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff73fa1"]])

export default __exports__